import { defineComponent as _defineComponent } from 'vue'
import { TitleOfferFragment } from '@/components/buybox/graphql/fragments/Offer.fragment';
import { computed, ref } from 'vue';
import BuyBox from '@/components/buybox/BuyBox.vue';
import { MonetizationType, TitleListType } from '@/@types/graphql-types';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { useI18n } from '@/helpers/composables/useI18n';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { EXCLUDED_PACKAGES } from '@/constants/buybox-excluded-packages.constant';
import { isTitleInList } from '@/helpers/title-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxBanner',
  props: {
    offerCount: null,
    offers: null,
    title: null,
    additionalContexts: null,
    appleQualityTvExpActive: { type: Boolean },
    isAVODActive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	offerCount: number;
	offers: TitleOfferFragment[];
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
	// AQTV_TITLEDETAIL_PLACEMENTS
	appleQualityTvExpActive: boolean;
	// AQTV_TITLEDETAIL_PLACEMENTS
	isAVODActive?: boolean;
};

const { t } = useI18n();
const { language } = useLanguageStore();

const showBuyBox = ref(false);



function toggleBuyBox() {
	showBuyBox.value = !showBuyBox.value;

	TrackingHelper.trackEvent(
		'userinteraction',
		{ action: 'dropdown_clicked', label: 'buybox', value: showBuyBox.value ? 1 : 0 },
		props.additionalContexts
	);

	// trackTitleDetailRedesignNewBuyBoxExp({ action: 'click', label: 'dropdown_clicked' });
}

function scrollTo(id: string) {
	const element = document.getElementById(id);
	if (element) {
		element.scrollIntoView({ behavior: 'smooth' });
	}
	TrackingHelper.trackEvent('userinteraction', {
		action: 'jumplink_clicked',
		label: id.replaceAll('-', '_'),
	});
	// trackTitleDetailRedesignNewBuyBoxExp({
	// 	action: 'click',
	// 	label: `jumplink_click_${id.replaceAll('-', '_')}`,
	// });
}

const showTheatreAndProviderText = computed(() => {
	return ['en', 'fr', 'de', 'es', 'tr', 'pt', 'it'].includes(language.value);
});

const hasOnlyCinemaOffers = computed(() => {
	return props.offers.every(offer => offer.monetizationType === MonetizationType.Cinema);
});

const cinemaOffersCount = computed(() => {
	return props.offers.filter(offer => offer.monetizationType === MonetizationType.Cinema).length;
});

const nonCinemaOffersCount = computed(() => {
	return providerCount.value - cinemaOffersCount.value;
});

const offerCountText = computed(() => {
	if (hasOnlyCinemaOffers.value) return t('WEBAPP_CURRENTLY_IN_THEATERS');

	if (cinemaOffersCount.value > 0 && showTheatreAndProviderText.value)
		return nonCinemaOffersCount.value === 1
			? t('WEBAPP_IN_THEATERS_AND_ON_STREAMING_SERVICE')
			: t('WEBAPP_IN_THEATERS_AND_ON_STREAMING_SERVICES', {
					count: nonCinemaOffersCount.value,
			  });

	return providerCount.value === 1
		? t('WEBAPP_AVAIL_ON_STREAMING_SERVICE')
		: t('WEBAPP_AVAIL_ON_STREAMING_SERVICES', {
				count: providerCount.value,
		  });
});

const hasApple = computed(() => props.offers.filter(offer => offer.package.packageId === 350));

const providerCount = computed(() => {
	// START AVOD
	// Only show One Plex offer at a time.
	// + Always filtering out Justwatch-plex Provider as it's only used by partners.
	const AVODTechnicalName = props.isAVODActive
		? ['plex', 'justwatchplexchannel']
		: ['plexplayer', 'justwatchplexchannel'];

	return [...new Map(props.offers.map(offer => [offer.package.packageId, offer])).values()].filter(
		offer =>
			// Filtering out TVOD providers we don't have a partnership with
			!EXCLUDED_PACKAGES.value.includes(offer.package.packageId) &&
			// Only show one plex offer
			!AVODTechnicalName.includes(offer.package.technicalName) &&
			// Remove amazon offers from apple titles
			(hasApple.value ? offer.package.packageId !== 9 : true)
	).length;
});

return { __sfc: true,t, language, showBuyBox, props, toggleBuyBox, scrollTo, showTheatreAndProviderText, hasOnlyCinemaOffers, cinemaOffersCount, nonCinemaOffersCount, offerCountText, hasApple, providerCount, BuyBox, TitleListType, isTitleInList }
}

})